import {
	DataAttributes,
	respondTo,
	respondToRange,
	StyledNotification,
	StyledNotificationRoot,
	StyledModalRoot,
} from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ZIndex } from "src/ui/constants";

export type MainProps = DataAttributes<{
	"screen-modals": boolean;
}>;

export const Developer = styled.aside``;
export const Main = styled.div<MainProps>``;

export const Root = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-flow: column nowrap;
		height: 100%;
		width: 100%;

		${Developer} {
			display: flex;
			width: 100%;
			flex: none;
		}

		${Main} {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			width: 100%;
			overflow: hidden;
			transition: transform 0.3s ease-out;
			z-index: ${ZIndex.Main};
		}

		${StyledModalRoot.Root} {
			z-index: ${ZIndex.Modal};
		}

		${StyledNotification.Root}[data-color="alert"],
		${StyledNotification.Root}[data-color="success"] {
			${StyledNotification.Icon} {
				border: 1px solid ${theme.colors.palette.black};
			}
		}

		${respondToRange(theme, "tablet", "down")} {
			${StyledNotificationRoot.Root} {
				padding: ${theme.components.notificationRoot.mobilePadding};
			}
		}

		${respondTo(theme, "mobile")} {
			${Main}[data-screen-modals] {
				transform: translateX(-${theme.components.screen.stackOffset});
			}
		}
	`}
`;
